import React from "react";
import point from "./../../../../../Images/point.png";

const HowOlaplexMaintain = () => {
  return (
    <div className="blogWhat-content">
      <h5>Maintaining Hair Health at Home with Olaplex Products</h5>
      <p>
        After your salon visit, maintaining your hair’s health at home is
        essential. Here’s how various Olaplex products can help you achieve
        that:
      </p>
      <ul>
        <li>
          <span>
            <img src={point} alt="point" />
            Olaplex No.0 Intensive Bond Building Treatment: A Pre-Treatment
            Powerhouse{" "}
          </span>
          <p>
            The Olaplex No.0 Intensive Bond Building Treatment is a primer
            designed to be used as the first step in your at-home hair care
            routine. It is an intensive treatment that prepares your hair for
            the Olaplex No.3 Hair Perfector. The No.0 treatment boosts the
            effectiveness of No.3 by providing additional protection and
            enhancing the repair process. When used together, these two products
            can provide up to 68% more repair and 3x stronger hair, making them
            a must-have for anyone looking to maintain healthy hair after
            coloring.
          </p>
        </li>
        <li>
          <span>
            <img src={point} alt="point" />
            Olaplex No.3 Hair Perfector: Your At-Home Repair Solution{" "}
          </span>
          <p>
            Olaplex No.3 Hair Perfector is the star of the Olaplex at-home
            range. This product is designed to be used once a week to strengthen
            and repair damaged hair. It helps maintain the results of your
            in-salon Olaplex treatment, ensuring that your hair remains healthy,
            shiny, and resilient. Applying No.3 to damp, towel-dried hair and
            leaving it on for at least 10 minutes (or longer for a more intense
            treatment) will provide you with a noticeable improvement in hair
            texture and strength.
          </p>
        </li>
        <li>
          <span>
            <img src={point} alt="point" />
            Olaplex No.4 Bond Maintenance Shampoo: Gentle Cleansing with a
            Purpose{" "}
          </span>
          <p>
            The Olaplex No.4 Bond Maintenance Shampoo is a nourishing shampoo
            that repairs, strengthens, and hydrates all hair types. It is
            formulated with the same patented technology that works to repair
            broken bonds. This shampoo is color-safe and helps reduce frizz
            while leaving your hair touchably soft and incredibly shiny. Using
            this shampoo regularly will help maintain your hair’s health and
            vibrancy after coloring, ensuring the color stays fresh and the hair
            remains strong.
          </p>{" "}
        </li>
        <li>
          <span>
            <img src={point} alt="point" />
            Olaplex No.5 Bond Maintenance Conditioner: Deep Hydration and Repair
          </span>
          <p>
            Olaplex No.5 Bond Maintenance Conditioner is a highly moisturizing,
            reparative conditioner for all hair types. It works to eliminate
            damage, frizz, and split ends while enhancing the hair's shine and
            softness. This conditioner penetrates deeply to nourish and
            strengthen the hair, keeping it healthy and hydrated. When used in
            conjunction with Olaplex No.4 Shampoo, it provides a comprehensive
            approach to maintaining your hair’s health after coloring.
          </p>{" "}
        </li>
        <li>
          <span>
            <img src={point} alt="point" />
            Olaplex No.6 Bond Smoother: Leave-In Styling for Smooth and
            Frizz-Free Hair
          </span>
          <p>
            The Olaplex No.6 Bond Smoother is a leave-in reparative styling
            cream that eliminates frizz, hydrates, and protects your hair. This
            product is perfect for maintaining your hair’s smoothness and
            strength between washes. It speeds up blow-drying time, and its
            highly concentrated formula means you only need a small amount to
            achieve results. Applying No.6 to damp or dry hair before styling
            will leave your hair feeling silky smooth, manageable, and
            frizz-free for up to 72 hours.
          </p>{" "}
        </li>
        <li>
          <span>
            <img src={point} alt="point" />
            Olaplex No.7 Bonding Oil: Shine, Protection, and Repair
          </span>
          <p>
            The Olaplex No.7 Bonding Oil is a lightweight, reparative styling
            oil that boosts shine, strengthens, and protects hair from heat
            damage up to 450°F (232°C). It works wonders for color-treated hair,
            enhancing its vibrancy and luster while also reducing frizz. Simply
            apply a few drops to damp or dry hair, focusing on the mid-lengths
            and ends, for a glossy finish that won’t weigh your hair down.
          </p>{" "}
        </li>
      </ul>
    </div>
  );
};

export default HowOlaplexMaintain;
